import request from '@/utils/request'

const fetchSettlements = (params) => {
  const requiredParams = {
    'sort[createdAt]': 'desc',
  }
  const { fromDate, toDate, ...rest } = params
  const dataToBeSent = { ...rest, ...requiredParams }

  if (fromDate) {
    dataToBeSent['createdAt[gte]'] = fromDate
  }

  if (toDate) {
    dataToBeSent['createdAt[lte]'] = toDate
  }

  return request(
    {
      path: '/merchants/settlement/list',
      method: 'GET',
      data: dataToBeSent,
    },
    {
      options: {
        cache: true,
      },
    }
  )
}

const fetchConfigs = (merchantId) => {
  return request(
    {
      path: `/merchants/${merchantId}/accounts`,
      method: 'GET',
    },
    {
      options: {
        cache: true,
        hideMessage: true,
      },
    }
  )
}

const fetchBreakdown = (countryCode, currency) => {
  return request({
    path: `/merchants/settlement/breakdown?country_code=${countryCode}&currency=${currency}`,
    method: 'GET',
  })
}

const updateSettlementModel = (merchantAccountId, model) => {
  return request({
    path: `/merchants/account/${merchantAccountId}/update-config`,
    method: 'PUT',
    data: {
      settlement_model: model,
    },
  })
}

const fetchSettlementDetails = (settlementId) => {
  return request(
    {
      path: `/merchants/settlement/detail`,
      method: 'GET',
      data: {
        settlement_reference: settlementId,
      },
    },
    {
      options: {
        cache: true,
        cacheTimeout: 5_000,
      },
    }
  )
}

export default {
  fetchSettlements,
  fetchConfigs,
  updateSettlementModel,
  fetchBreakdown,
  fetchSettlementDetails,
}
